import React from 'react'
import { Routes, Route } from 'react-router-dom'

import SiteLayout from '@components/marketing/SiteLayout'
import SaaSLandingPage from '@pages/marketing/SaaSLandingPage'
import PlatformPage from '@pages/marketing/PlatformPage'
import SportsPage from '@pages/marketing/SportsPage'
import LiveScoringPage from '@pages/marketing/LiveScoringPage'
import StandingsPage from '@pages/marketing/StandingsPage'
import WhoItsForPage from '@pages/marketing/WhoItsForPage'
import DemoPage from '@pages/marketing/DemoPage'
import NotFoundPage from '@pages/common/NotFoundPage'

// Every marketing page is its own URL with its own title and description, so
// each can be found on its own terms rather than as an anchor on the home page.
const MarketingRoutes = () => (
  <Routes>
    <Route element={<SiteLayout />}>
      <Route path="/" element={<SaaSLandingPage />} />
      <Route path="/platform" element={<PlatformPage />} />
      <Route path="/sports" element={<SportsPage />} />
      <Route path="/live-scoring" element={<LiveScoringPage />} />
      <Route path="/standings" element={<StandingsPage />} />
      <Route path="/who-its-for" element={<WhoItsForPage />} />
      <Route path="/demo" element={<DemoPage />} />
      <Route path="/contact" element={<DemoPage />} />
    </Route>
    <Route path="*" element={<NotFoundPage />} />
  </Routes>
)

export default MarketingRoutes
